export default __webpack_public_path__ + "static/media/Power_Małgorzata Szmigeil_WAKACJE.305daa59.pdf";